import React, { Component } from "react";
import Slider from "react-slick";
import styled from "styled-components";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { IPFSContext } from "contexts/IPFSProvider";
import './style.scss';

const Outer = styled.div`
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  height: 260px;
  overflow: hidden;
  border-radius: 8px;
`;



class CustomSlide extends Component {
  render() {
    const { index, ...props } = this.props;
    return (
      <div {...props}></div>
    );
  }
}

export default class Responsive extends Component {

  static contextType = IPFSContext

  

  constructor(props) {
      super(props);
      this.state = { nfts: props.nftInfo, height: 0, ipfs: "" };
      console.log("nftInfo ==========> ", props.nftInfo);
      this.onImgLoad = this.onImgLoad.bind(this);
      console.log(IPFSContext);
     // this.itemSelect("asd",9);
      
  }

  onImgLoad({target:img}) {
    let currentHeight = this.state.height;
    if(currentHeight < img.offsetHeight) {
        this.setState({
            height: img.offsetHeight
        })
    }
  }
  itemSelect = (tokenURI, tokenID) => {
    const {ipfsClick} = this.context;
    const tokenIDInt = parseInt(tokenID);
   console.log(ipfsClick);
    ipfsClick(tokenURI, tokenIDInt);
  };




  render() {
    var settings = {
      infinite: false,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      initialSlide: 0,
      adaptiveHeight: 300,
      responsive: [
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            infinite: true
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true
          }
        }
      ]
    };
    return (
        <div className='nft'>
          <Slider {...settings}>
            {this.state.nfts.map( (nft, key) => (
              <CustomSlide className='itm' index={key}>
                <div className="d-item">
                  <div className="nft__item" onClick={() => this.itemSelect(nft.tokenURI, nft.tokenID)}>
                      <div className="nft__item_wrap" style={{height: `${this.state.height}px`}}>
                        <Outer>
                          <span>
                              <img onLoad={this.onImgLoad} src={nft.tokenURI} className="lazy nft__item_preview"   alt=""/>
                          </span>
                        </Outer>
                      </div>
                      <div className="nft__item_info price">
                          <span>
                              <h4>{nft.tokenName}</h4>
                          </span>
                          <div className="nft__item_price price">
                              Token ID : <span>{nft.tokenID}</span>
                          </div>           
                      </div> 
                  </div>
                </div>
              </CustomSlide>
            ))}
          </Slider>
        </div>
    );
  }
}
